<div class="selection-tag-container" [ngStyle]="{'justify-content': !displaySelectionTags ? 'center' : ''}">
  @if (useHorizontalScroller) {
    <button #Previous
      data-automation-id="lm-list-selection-tag-previous-btn"
      id="ScrollPreviousButton"
      [ngStyle]="{'visibility': previousHidden || !displaySelectionTags ? 'hidden' : 'visible'}"
      soho-button="icon"
      icon="previous-page"
      (click)="scrollPrevious()">Previous
    </button>
    <lm-horizontal-scroller #HorizontalScroller
      (overflowed)="onOverflowed($event)"
      (scrollIsStartEvent)="onScrollIsStartEvent($event)"
      (scrollIsEndEvent)="onScrollIsEndEvent($event)"
      >
      @for (item of selectionTags; track trackById(i, item); let i = $index) {
        <span class="tag is-dismissible secondary" [ngClass]="{'is-focused':isFocused(item.tag)}">
          <ng-container>
            <span class="audible">Close</span>
            <p class="tag-content"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-field"
              [id]="item.tag"
              >
              <span class="lm-selection-tag-value"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-value">{{item.tag}}</span>
            </p>
            <button #SelectionTag
              class="btn-dismissible"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-remove-button"
              id="{{item.id}}_{{item.tag}}_remove_button"
              attr.data-tag="{{item.tag}}"
              (click)="onRemoveTag(i)"
              (focus)="setFocusedTag(item.tag)"
              (blur)="setFocusedTag(null)"
              >
              <svg soho-icon [icon]="iconName" class="icon"></svg>
              <span class="audible">Close</span>
            </button>
          </ng-container>
          <span class="audible">Close</span>
        </span>
      }
    </lm-horizontal-scroller>
    <button #Next
      data-automation-id="lm-list-selection-tag-next-btn"
      id="ScrollNextButton"
      [ngStyle]="{'visibility': nextHidden || !displaySelectionTags ? 'hidden' : 'visible'}"
      soho-button="icon"
      icon="next-page"
      (click)="scrollNext()">Next
    </button>
  } @else {
    <div [ngStyle]="{'display': displaySelectionTags ? 'none' : 'inline-block'}">
      <span class="tag is-dismissible hide-focus lpl-blue-bg"
        [ngStyle]="{'color': '#FFFFFF', 'display': 'inline-block', 'outline': 'none'}"
      >{{editModeTagLabel}}</span>
    </div>
    <div class="scrollable-tags" [ngStyle]="{'display': displaySelectionTags ? 'inline-block' : 'none'}">
      @for (item of selectionTags; track trackById(i, item); let i = $index) {
        <span class="tag is-dismissible secondary" [ngClass]="{'is-focused':isFocused(item.tag)}">
          <ng-container>
            <span class="audible">Close</span>
            <p class="tag-content"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-field"
              [id]="item.tag"
              >
              <span class="lm-selection-tag-value"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-value">{{item.tag}}</span>
            </p>
            <button #SelectionTag
              class="btn-dismissible"
              attr.data-automation-id="lm-{{item.id}}-{{item.tag}}-remove-button"
              id="{{item.id}}_{{item.tag}}_remove_button"
              attr.data-tag="{{item.tag}}"
              (click)="onRemoveTag(i)"
              (focus)="setFocusedTag(item.tag)"
              (blur)="setFocusedTag(null)"
              >
              <svg soho-icon [icon]="iconName" class="icon"></svg>
              <span class="audible">Close</span>
            </button>
          </ng-container>
          <span class="audible">Close</span>
        </span>
      }
    </div>
  }
</div>

<!-- Contain selection tags within horizontal scroller -->

<!-- Contain selection tags in div -->
